import { useExistingNarrative } from '@/hooks/narrative/useExistingNarrative';
import {
  DeferRender,
  MiniPriceChartDefinitions,
  NarrativeMiniPriceChart,
  DeprecatedNarrativeMiniPriceChart2,
} from '@components/MiniPriceChart';
import type { HoverParam } from '@components/MiniPriceChart';
import useUser from '@/hooks/useUser';
import { CURRENT_PERIOD } from '../../constants';
import { useFlag } from '@simplywallst/unleash';

const CHART_HEIGHT = 70; // Value to match height of first column on small desktop

type Props = {
  companyId: string;
  onHover?: (param: HoverParam) => void;
};

const ChartBones = () => (
  <div
    className="min-h-[--chart-h]"
    style={{ '--chart-h': `${CHART_HEIGHT}px` } as React.CSSProperties}
  />
);

export const NarrativeKeyMetricChart = ({ companyId, onHover }: Props) => {
  const { data: user } = useUser();
  const { data: existingNarrative, status } = useExistingNarrative({
    companyId,
    loggedIn: user.loggedIn,
  });
  const valuationHistoryFlag = useFlag(
    'mono-narrative-valuation-history-chart'
  );

  if (status === 'pending') {
    return <ChartBones />;
  }

  if (status === 'error') {
    return (
      <div
        className="grid min-h-[--chart-h] place-items-center"
        style={{ '--chart-h': `${CHART_HEIGHT}px` } as React.CSSProperties}
      >
        <p className="text-xs text-bad">An error occurred</p>
      </div>
    );
  }

  const { myValuation } = existingNarrative.Company ?? {};

  return (
    <div>
      <MiniPriceChartDefinitions />
      <DeferRender fallback={<ChartBones />}>
        {valuationHistoryFlag.enabled ? (
          <NarrativeMiniPriceChart
            companyId={companyId}
            period={CURRENT_PERIOD}
            align="left"
            valuations={myValuation?.narrative?.valuations ?? null}
            onHover={onHover}
          />
        ) : (
          <DeprecatedNarrativeMiniPriceChart2
            companyId={companyId}
            period={CURRENT_PERIOD}
            align="left"
            fairValue={myValuation?.fairValue ?? null}
            onHover={onHover}
          />
        )}
      </DeferRender>
    </div>
  );
};
